import {
  Component,
  ContentChildren,
  ElementRef,
  HostBinding,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { NavPillsItemDirective } from './nav-item.directive';
import { NavPillsInnerItemContainerDirective } from './nav-pills-inner-item.directive';

@Component({
  selector: 'rd-shared-nav-pills',
  templateUrl: './nav-pills.component.html',
  styleUrls: ['./nav-pills.component.scss'],
  standalone: false,
})
export class NavPillsComponent {
  @ContentChildren(NavPillsItemDirective)
  items: QueryList<NavPillsItemDirective>;
  @ViewChildren(NavPillsInnerItemContainerDirective, { read: ElementRef })
  innerItemContainers: QueryList<ElementRef>;
  @ViewChild('navPills') navPills: ElementRef;
  @HostBinding('class.rd-shared-nav-pills') componentClass = true;
}
